import { DeleteIcon, EditIcon } from '@chakra-ui/icons';

export const columnsDataClients = [
  {
    Header: "Fecha",
    accessor: "date",
  },
  {
    Header: "Hora",
    accessor: "time",
  },
  {
    Header: "Cliente",
    accessor: "customer.name",
  },
  {
    Header: "Chasis",
    accessor: "vehicle.chassisNumber",
  },
  {
    Header: "Matrícula",
    accessor: "vehicle.plate",
  },
  {
    Header: "Marca",
    accessor: "vehicle.brand",
  },
  {
    Header: "Operario",
    accessor: "mechanic.name",
  },
  {
    Header: "Modelo",
    accessor: "vehicle.model.description",
  },
  {
    Header: "Tipo",
    accessor: "serviceType.name",
  },
  {
    Header: "Servicio",
    accessor: "service.name",
  },
  {
    Header: "Estado",
    accessor: "status.name",
  },
  {
    Header: '',
    accessor: 'actions',
    actions: [
      {
        label: 'Editar',
        icon: <EditIcon />,
        colorScheme: 'blue',
        type: 'edit'
      },
      {
        label: 'Eliminar servicio cancelado',
        icon: <DeleteIcon />,
        colorScheme: 'red',
        type: 'delete'
      },
    ]
  }
];
